<script setup lang="ts">
import { AgreementField } from '~/components/auth/fields/';
import { RegisterForm } from '~/components/auth/forms/';
import { LoginOrRegister } from '~/components/auth/labels/';
import { AppTypography } from '~/components/base/';
import RegisterPage from '~/utils/contents/auth/pages/RegisterPage';

definePageMeta({ layout: 'split', auth: false, middleware: 'guest' });

useHead({
  title: RegisterPage.seo.title,
});
</script>

<template>
  <div
    class="register-page flex flex-col items-center justify-center text-center"
  >
    <div class="register-page__header mb-5">
      <AppTypography type="title-4" element="h4" class="mb-2">{{
        RegisterPage.title
      }}</AppTypography>
      <AppTypography type="body">{{ RegisterPage.subtitle }}</AppTypography>
    </div>
    <RegisterForm
      class="register-page__form mb-10"
      data-testid="register-form"
    />
    <div class="register-page__footer">
      <LoginOrRegister go-to="login" class="mb-10" data-testid="login-link" />
      <AgreementField data-testid="agreement" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.register-page {
  max-width: 486px;
}
</style>
